import Backbone from 'backbone'
import template from './set-operator-select.hbs'
import filterOperators from 'scoreboard/reports/common/filter/filter-operators'

const SetOperatorSelect = Backbone.View.extend({

	className: 'set-operator-select',

	initialize: function(options = {}) {
		this.options = options
		this.data = options.data || {}
	},

	render: function() {
		this.$el.html(template({ label: this.options.label }))
		filterOperators.populate(this.$('.operator-type'), 'set',
			this.data.operator)
		return this
	},

	gather: function(e) {
		this.data.operator = this.$('select.operator-type').val()
		return this.data
	}
})

export default SetOperatorSelect

SetOperatorSelect.__filename__ = 'reports/wizard/filter-meta/set-operator-select.js'
